// Label prefixes for data sources (no emojis)
export const sourcePrefixes = {
  SITREP: 'SITREP',
  Files: 'Files',
  Web: 'Web',
  News: 'News',
  'Current Weather': 'Weather',
  'Forecast Weather': 'Forecast',
  Incident: 'Incident',
  'NEO Analysis': 'NEO',
  Exercise: 'Exercise',
  'Map Layers': 'Layers',
};

export const LocationRequiredDataSources = [
  {
    source: 'Current Weather',
    description: 'LOCATION REQUIRED (Event).  Current weather at location.',
    id: '',
  },
  {
    source: 'Forecast Weather',
    description: 'LOCATION REQUIRED (Event).  Forecast weather at location.',
    id: '',
  },
];

export const DChatDataSources = [
  {
    source: 'Incident',
    description:
      'Complete incident ICS data. Auto-detects if current or historical data is needed based on your query.',
    id: '',
  },
  {
    source: 'Exercise',
    description:
      'Complete exercise planning data including scenarios, participants, objectives, and MSEL injects.',
    id: '',
  },
  {
    source: 'Map Layers',
    description:
      'Map layers and their features (internal layers plus external ArcGIS layers). Summarized — counts, bounding boxes, distances — never raw geometry.',
    id: '',
  },
];
